import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import {
  Form,
  Input,
  Cascader,
  Select,
  message,
  notification,
  Spin,
  Switch,
  Upload,
  Button,
  AutoComplete,
  Modal,
  Radio,
  Icon,
} from 'antd';
import {
  LoadingOutlined,
  UploadOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import _ from 'lodash';
import './styles.module.scss';
import AppHelper from 'libs/AppHelper';
import { API_HOST, LOGIN_LINK } from '../../configs/env';
import whttp from '../../libs/whttp';
import { genFormItemAtrribute } from 'libs/FormHelper';
import NavTab from 'components/NavTab/NavTab';
import classnames from 'classnames';
import queryOptionsProd from './queryOptions.json';
import queryOptionsDev from './queryOptionsDev.json';
import queryTargetOptions from './queryTargetOptions.json';
import querySubjectOptions from './querySubjectOptions.json';
import retailChannelOptions from './retailChannelOptions.json';
import { __ } from '@wordpress/i18n';
import WUpload, { AvatarUpload } from 'components/WUpload/WUpload';
import qs from 'query-string';
import moment from 'moment';
import WJSON from 'libs/wjson';

const VC_CONFIG = _.get(window, 'VC_CONFIG', {});
const PLUGIN_ASSETS_URL = _.get(window, 'VC_CONFIG.PLUGIN_ASSETS_URL');

const stringToBr = (text) => {
  return _.map(_.split(text, '\n'), (line, idx) => (
    <Fragment key={idx}>
      {line}
      <br />
    </Fragment>
  ));
};

// 前端頁面
export default class FeedBack extends Component {
  formRef = React.createRef();

  state = {
    value1: null,
    value2: null,
    value3: null,
    URLQuery: {},
    isSubmitData: false,
  };

  componentDidMount() {
    const Query = AppHelper.getURLQuery();
    this.setState({ URLQuery: Query });
    console.log('test', AppHelper.getURLQuery());
  }
  submitData = (info = {}) => {
    const SerialID = _.get(this, 'state.URLQuery.sid');
    const Var_Number = _.get(this, 'state.URLQuery.nid');
    console.log('submitData-3', SerialID, Var_Number);
    if (!SerialID || !Var_Number) {
      Modal.error({
        title: '序號遺失，請與客服中心聯絡',
      });
    } else {
      info.SerialID = SerialID;
      info.Var_Number = Var_Number;

      console.log('submitData-2', info);

      ///feedback?nid=Web2018011000999&sid=CCFS2018011000814

      this.setState({ isSubmitData: true, messages: {} });

      whttp.post(
        API_HOST + `/api/contactus/custFeedBack`,
        info,
        (state, res) => {
          console.log(state, res);

          this.setState({ isSubmitData: false });

          const { code = 100, reason = '發生錯誤', data = {} } = res;

          if (state === false) {
            return message.error('發生錯誤');
          }

          if (code !== 200) {
            Modal.error({
              content: '送出失敗，請稍後再試',
            });

            return this.setState({ messages: data.messages || {} });
          }

          Modal.success({
            content: '送出成功，感謝您填寫資料',
            onOk: () => {
              window.location.href = VC_CONFIG.INDEX_URL;
            },
          });
        }
      );
    }
  };

  render() {
    const options = [
      { label: '非常滿意', value: 1 },
      { label: '滿意', value: 2 },
      { label: '普通', value: 3 },
      { label: '不滿意', value: 4 },
      { label: '非常不滿意', value: 5 },
    ];
    const { value1, value2, value3 } = this.state;
    const antIcon = (
      <img
        id='loadingImg'
        src={`${
          VC_CONFIG.INDEX_URL
        }/wp-content/themes/cec/assets/img/logo/loading.gif`}
        alt=''
      />
    );

    return (
      <Fragment>
        <main class='bg-light' id='feedbackmain'>
          <Spin
            style={{ width: '100%', height: '100%' }}
            spinning={this.state.isSubmitData}
            size='large'
            indicator={antIcon}
          >
            <div class='container' id='feedback'>
              <div class='breadcrumb-wrap py-4 m-0'>
                <nav aria-label='breadcrumb'>
                  <ol class='breadcrumb'>
                    <li class='breadcrumb-item'>
                      <a href={`${VC_CONFIG.INDEX_URL}`}>首頁</a>
                    </li>
                    <li class='breadcrumb-item active' aria-current='page'>
                      提供意見
                    </li>
                  </ol>
                </nav>
              </div>
              <h4 class='heading-title align-items-center'>提供意見</h4>
              <hr class='border-top border-gray mt-0 mb-4' />
              <Form
                noStyle
                ref={this.formRef}
                name='basic'
                layout='vertical'
                onFinish={(values) => {
                  this.submitData(values);
                }}
                //onFieldsChange={(changedFields, allFields) => {
                //     console.log('onFieldsChange', _.reduce(allFields, (r, i) => {
                //       r[i.name.join('.')] = i.value
                //       return r
                //    }, {}),changedFields, allFields)
                //  }
                // }
              >
                <div class='row no-gutters mx-n3 mb-4 stre'>
                  <div class='col-lg-3 px-3'>
                    <div class='card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'>
                      <div class='card-body pb-0 pt-5 p-lg-5'>
                        <h5 class='h4 text-navy text-center'>回覆滿意度 *</h5>
                      </div>
                    </div>
                  </div>
                  <div class='col-lg-9 px-3'>
                    <div class='card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'>
                      <div class='card-body p-5'>
                        <Form.Item
                          {...genFormItemAtrribute('Var_Whole')}
                          rules={[
                            { required: true, message: '請選擇回覆滿意度' },
                          ]}
                        >
                          <Radio.Group
                            options={options}
                            onChange={(e) => {
                              this.setState({ value1: e.target.value }, () => {
                                console.log('value 1 :', this.state.value1);
                              });
                            }}
                            value={value1}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </div>
                <div class='row no-gutters mx-n3 mb-4 stre'>
                  <div class='col-lg-3 px-3'>
                    <div class='card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'>
                      <div class='card-body pb-0 pt-5 p-lg-5'>
                        <h5 class='h4 text-navy text-center'>回覆速度 *</h5>
                      </div>
                    </div>
                  </div>
                  <div class='col-lg-9 px-3'>
                    <div class='card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'>
                      <div class='card-body p-5'>
                        <Form.Item
                          {...genFormItemAtrribute('Var_Reply')}
                          rules={[
                            { required: true, message: '請選擇回覆速度滿意度' },
                          ]}
                        >
                          <Radio.Group
                            options={options}
                            onChange={(e) => {
                              this.setState({ value2: e.target.value }, () => {
                                console.log('value 2 :', this.state.value2);
                              });
                            }}
                            value={value2}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </div>
                <div class='row no-gutters mx-n3 mb-4 stre'>
                  <div class='col-lg-3 px-3'>
                    <div class='card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'>
                      <div class='card-body pb-0 pt-5 p-lg-5'>
                        <h5 class='h4 text-navy text-center'>服務水準 *</h5>
                      </div>
                    </div>
                  </div>
                  <div class='col-lg-9 px-3'>
                    <div class='card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'>
                      <div class='card-body p-5'>
                        <Form.Item
                          {...genFormItemAtrribute('Var_Service')}
                          rules={[
                            { required: true, message: '請選擇服務水準滿意度' },
                          ]}
                        >
                          <Radio.Group
                            options={options}
                            onChange={(e) => {
                              this.setState({ value3: e.target.value }, () => {
                                console.log('value 3 :', this.state.value3);
                              });
                            }}
                            value={value3}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </div>
                <div class='row justify-content-center' id='feedbackbotton'>
                  <div class='col-sm-2'>
                    <Button
                      type='primary'
                      size='large'
                      onClick={(e) => {
                        Modal.confirm({
                          icon: <ExclamationCircleOutlined />,
                          title: '注意',
                          content: (
                            <div>
                              <p>您所填寫的資料將不儲存</p>
                              <p>您確定離開此頁面嗎？</p>
                            </div>
                          ),
                          onOk() {
                            window.location.href = VC_CONFIG.INDEX_URL;
                          },
                        });
                      }}
                    >
                      　取消　
                    </Button>
                  </div>
                  <div class='col-sm-1'>
                    <Button
                      type='primary'
                      size='large'
                      onClick={(e) => {
                        e.preventDefault();
                        this.formRef.current.submit();
                      }}
                    >
                      確認送出
                    </Button>
                  </div>
                </div>
              </Form>
            </div>
          </Spin>
        </main>
      </Fragment>
    );
  }
}

// 編輯器
export class FeedBackEditor extends Component {
  render() {
    return <div className='vu-blocks-editor'>編輯器</div>;
  }
}



// WEBPACK FOOTER //
// ./src/blocks/customer-service/feedback.js